"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const capitalize_1 = require("./capitalize");
const tokenize_1 = require("./tokenize");
/**
 * Camel case the given string.
 *
 * @Param {string} text = The text to camel case.
 *
 * @Example
 *
 *   camelCase('PizzaSlize')
 *   //=> "pizzaSlize"
 *
 *   camelCase('PIZZA_SLIZE')
 *   //=> "pizzaSlize"
 *
 *   camelCase('kebab-pizza-slize')
 *   //=> "kebabPizzaSlize"
 *
 *   camelCase('pizza_slize')
 *   //=> "pizzaSlize"
 *
 *   camelCase('pizza slize')
 *   //=> "pizzaSlize"
 */
function camelCase(text) {
    const [firstToken, ...trailingTokens] = tokenize_1.tokenize(text);
    return [firstToken.toLowerCase(), ...trailingTokens.map(capitalize_1.capitalize)].join('');
}
exports.camelCase = camelCase;
//# sourceMappingURL=camel-case.js.map